import React, { useState, useRef } from 'react';
import { makeStyles } from '@mui/styles';
import { Paper ,Card ,CardContent ,MenuItem ,TextField ,Typography, Button, Grid, Select, FormControl, InputLabel } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import html2pdf from 'html2pdf.js';
import HeightBox from '../components/HeightBox';
import { PDFDownloadLink, Document, Page, View, Text, Image, Font } from '@react-pdf/renderer';
import http from "../http-common"
import { Editor } from '@tinymce/tinymce-react';

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '210mm',
    height: '290mm',
    padding: theme.spacing(4),
  },
  content: {
    marginBottom: theme.spacing(2),
  },
  toolbox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: 'white',
  },
  uploadButton: {
    marginTop: theme.spacing(2),
  },
  outputContainer: {
    lineHeight: ({ lineHeight }) => lineHeight,
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const FormsAll = () => {
  const [backgroundImage, setBackgroundImage] = useState('');
  const [date, setDate] = useState('2023-01-01');
  const [address, setAddress] = useState('');
  const [header, setHeader] = useState('');
  const [body1, setBody1] = useState('');
  const [body2, setBody2] = useState('');
  const [footer, setFooter] = useState('');
  const [templateName , setTemplateName] = useState('');
  const [lineHeight, setLineHeight] = useState('1.2em'); 
  const [letterTemplates, setLetterTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [selectedCandidate,setSelectedCandidate] = useState(''); 
  const [topSpacing, setTopSpacing] = useState('0');
  const [regNumber, setRegNumber] = useState('');
  const [name, setName] = useState('');
  const [nic, setNic] = useState('');
  const [country,setCountry] = useState('');
  const [passportNo,setPassportNo] = useState('');
  const [job,setJob] = useState('');
  const [passportNumber,setPassportNumber] = useState('');

  const classes = useStyles({ lineHeight });
  const componentRef = useRef();

  React.useEffect(() => {
    // Function to update the date state to today's date
    const updateTodayDate = () => {
      const today = new Date();
      console.log(today.toLocaleDateString('en-GB'))  
      setDate(today.toLocaleDateString('en-GB'));
    };

    // Call the updateTodayDate function to set the state when the component mounts
    updateTodayDate();

    // If you only want to update the state once when the component mounts, you can omit the second parameter (an empty array) in the useEffect hook.
    // If you want to update the state on some condition or trigger, you can include the dependency in the array.
  }, []);

  React.useEffect(() => {
    if (selectedTemplate) {
      const selectedTemplateObject = letterTemplates.find((template) => template.id === selectedTemplate);
      console.log(selectedTemplateObject)
      setBody1(selectedTemplateObject.body);
      setLineHeight(selectedTemplateObject?.extraField?.lineHeight || 1);
      setTopSpacing(selectedTemplateObject?.extraField?.topSpacing || 0);
      // setLineHeight(selectedTemplateObject.extraField.lineHeight);
    }
  }, [selectedTemplate, letterTemplates]);


  React.useEffect(() => {
    fetchLetterTemplates()
  }, []);
  
  const handleBackgroundUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      setBackgroundImage(e.target.result);
    };

    reader.readAsDataURL(file);
  };

  const handleLineHeightChange = (event) => {
    setLineHeight(event.target.value);
  };

  const handleDownload = () => {
    const element = componentRef.current;

    const opt = {
      margin: 0,
      filename: `${name}.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 10 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    html2pdf().from(element).set(opt).save();
  };
  React.useEffect(() => {
    console.log(topSpacing)
  }, [topSpacing]);

  const createLetterTemplate = async () => {
    try {
      const requestBody = {
        name: templateName,
        body: body1,
        extraField:{
          lineHeight: lineHeight,
          topSpacing: topSpacing,
        }
      };

      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
      const response = await fetch('https://oseas-api.hypen.lk/api/v1/candidates/letterTemplate', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        // Request successful
        alert('Letter template created successfully')
        fetchLetterTemplates()
        // Process the response data
      } else {
        // Request failed
        console.error('Request failed:', response.status);
      }
    } catch (error) {
      console.error('Request failed:', error.message);
    }
  };

  const fetchLetterTemplates = async () => {
    try {

      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
      const response = await fetch('https://oseas-api.hypen.lk/api/v1/candidates/letterTemplate/1', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        // Request successful
        const templates = await response.json();
        console.log(templates)
        setLetterTemplates(templates)
        // Process the response data
      } else {
        // Request failed
        console.error('Request failed:', response.status);
      }
    } catch (error) {
      console.error('Request failed:', error.message);
    }
  };
  const fetchCandidate = async () => {
    try {

      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
      const response = await fetch(`https://oseas-api.hypen.lk/api/v1/candidates/${regNumber}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        // Request successful
        const candidate = await response.json();
        console.log(candidate)
        setSelectedCandidate(candidate)
        setName(candidate.fullName)
        setNic(candidate.nic)
        setCountry(candidate.personalInfo.interestedToWork)
        setPassportNo(candidate.passportNo)
        setPassportNumber(candidate.passportNo)
        setJob(candidate.personalInfo.appliedPosition)
        // Process the response data
      } else {
        // Request failed
        console.error('Request failed:', response.status);
      }
    } catch (error) {
      console.error('Request failed:', error.message);
    }
  };

  const replacePlaceholders = (content) => {
    let replacedContent = content;
    const placeholders = content.match(/\${(.*?)}/g);
    console.log(placeholders)
    if (placeholders) {
      placeholders.forEach((placeholder) => {
        const variableName = placeholder.replace('${', '').replace('}', '');
        let variableValue;
  
        try {
          console.log(variableName)
          variableValue = eval(variableName);
          console.log(variableValue)
        } catch (error) {
          variableValue = undefined; // Handle eval error by setting variableValue to undefined
        }
  
        if (variableValue !== undefined && variableValue !== null) {
          replacedContent = replacedContent.replace(placeholder, variableValue);
        }
      });
    }
  
    return replacedContent;
  };
  

  const MyPDF = ({ processedBody1, backgroundImage }) => (
    <Document>
      <Page size="A4">
        <View style={{ position: 'absolute', width: '100%', height: '100%' }}>
          <Image src={backgroundImage} style={{ width: '100%', height: '100%' }} />
        </View>
        <View>
          <Text style={{ fontFamily: 'Roboto' }} dangerouslySetInnerHTML={{ __html: processedBody1 }} />
        </View>
      </Page>
    </Document>
  );

  // Register the font for use in PDF rendering
Font.register({
  family: 'Roboto',
  src: 'https://fonts.googleapis.com/css2?family=Roboto&display=swap',
});


  const processedBody1 = replacePlaceholders(body1);

  //tiny mc  test
  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
      setBody1(editorRef.current.getContent())
    }
  };

   // Complete list of toolbar options
   const modules = {
    toolbar: [
      [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
      [{ 'size': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['link', 'image', 'video'],
      ['clean']
    ],
  };

  return (
    <>
      <Grid container spacing={2}>
       
       
          <Grid item xs={2}>
          <Button variant="contained" color="primary" style={{ marginRight: '10px' }} onClick={fetchLetterTemplates}>
            Load Templates
          </Button>
          </Grid>
          <Grid item xs={12}>
          <FormControl sx={{ m: 1, minWidth: 400 }}>
          <InputLabel id="demo-multiple-name-label">Name</InputLabel>
          <Select
           size="small" 
           labelId="demo-simple-select-label" 
           id="demo-simple-select" 
           value={selectedTemplate} 
           label="Template Name" 
           onChange={(e) => setSelectedTemplate(e.target.value)}
           MenuProps={MenuProps}
           >
            {letterTemplates.map((template) => (
              <MenuItem key={template.id} value={template.id}>{template.name}</MenuItem>
            ))}
          </Select>
        
          </FormControl>
          </Grid>
          <Grid item xs={2}>
          
          <TextField size='small' label="Reg Number" fullWidth value={regNumber} onChange={(e) => setRegNumber(e.target.value)} />
          </Grid> 
          <Grid item xs={3}>

          <Button variant="contained" color="primary" style={{ marginLeft: 2 }} onClick={fetchCandidate}>
            Load Candidate
          </Button>
          </Grid>
          <Grid item xs={2}>
          <Button variant="contained" style={{ marginLeft: 2 }} color="secondary" onClick={handleDownload}>
            Download
          </Button> 
          </Grid> 




          <Grid item xs={12}>
          <Paper
            className={classes.paper}
            style={{ backgroundImage: `url(${backgroundImage})`,backgroundColor:'white' }}
            ref={componentRef}
          >
            <HeightBox height={topSpacing}/>           
            <Typography variant="body1" paragraph>
              <div
                className={classes.outputContainer}
                style={{ lineHeight,marginLeft:30 }}
                dangerouslySetInnerHTML={{ __html: processedBody1 }}
              ></div>
            </Typography>
            
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2} className={classes.toolbox}>
            <Grid item xs={12}>
              <TextField
                label="Date"
                fullWidth
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />

            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Top Spacing"
                fullWidth
                value={topSpacing}
                onChange={(e) => setTopSpacing(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
           
              <ReactQuill
                modules={modules}
              value={body1} onChange={setBody1} />
            </Grid>
        
        
            <Grid item xs={12}>
              <TextField
                label="Line Height"
                fullWidth
                value={lineHeight}
                onChange={handleLineHeightChange}
              />
            </Grid>
            <Grid item xs={12}>
              <input
                accept="image/*"
                type="file"
                id="backgroundImage"
                style={{ display: 'none' }}
                onChange={handleBackgroundUpload}
              />
              <label htmlFor="backgroundImage">
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  className={classes.uploadButton}
                >
                  Upload Background Image
                </Button>
              </label>
            </Grid>
          
            <Grid item xs={12}>
              <TextField
                label="Template Name"
                fullWidth
                value={templateName}
                onChange={(e) => setTemplateName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <Button variant="contained" color="primary" onClick={createLetterTemplate}>
                Create Letter Template
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default FormsAll;
